import axios from "axios";
import { env } from "../env";

// Overall preview
// when the app starts the in the DataContext the APIAuthinticate function will excute and it will request a token and a refresh token
// the Tokens will be stored in the session storage
// the auth header will be attached using axiosSW.interceptors.request.use before calling any API endpoint
// if the token is expired respond will be 401, in this case the axiosSW.interceptors.request.use will handle the logic

// IMPORTANT!  Any useEffect that calls an endpoint or excuting a function that calls an endpoint is protected by a condition if(JWTToken)
// and the JWTToken is added to the useEffect dependencies.

// Axios instances for different services

// The stripe and recaptcha endpoints
export const axiosSC = axios.create({
    baseURL: env.REACT_APP_CAPTCHA_STRIPE_API_URL,
    headers: {
        "Content-Type": "application/json",
    },
});

// The API authorisation token endpoints
export const axiosJWT = axios.create({
    baseURL: env.REACT_APP_SCHWEERS_API_AUTH_URL,
    headers: {
        post: {
            Accept: "text/plain",
            "Content-Type": "application/json",
        },
    },
});

// the Schweers server endpoints
export const axiosSW = axios.create({
    baseURL: env.REACT_APP_SCHWEERS_API_URL,
    headers: {
        common: {
            Accept: "text/plain",
            "Content-Type": "application/json",
        },
    },
});

//--------------------------------------------------------------- probably temporary
// the Schweers server endpoints for payment stripe connect
export const axiosSW2 = axios.create({
    baseURL: env.REACT_APP_SCHWEERS_API_URL_2,
    headers: {
        common: {
            Accept: "text/plain",
            "Content-Type": "application/json",
        },
    },
});
//--------------------------------------------------------------- probably temporary

// The POS user login endpoint
export const axiosSWLogIn = axios.create({
    baseURL: env.REACT_APP_SCHWEERS_API_URL,
    headers: {
        common: {
            Accept: "text/plain",
            "Content-Type": "application/json",
        },
    },
});

// Store the refresh token promise to avoid multiple simultaneous refresh requests
let refreshTokenPromise = null;

// The refreshAccessToken will use the refresh token to get a new token this will hapen through the axiosJWT connection wich is not intercepted
// and if successfull it wil update both the token and the refresh token
// if an error occured (no token) the function will clear the session storage and will reset the page by forcing page reload
// this will force the APIAuthintication() function in the DataContext to fetch a new token
const refreshAccessToken = async () => {
    // Only proceed if there's no ongoing refresh token request
    if (!refreshTokenPromise) {
        refreshTokenPromise = (async () => {
            try {
                // const refreshToken = JSON.parse(
                //     localStorage.getItem("JWTRefreshToken")
                // );
                const storedToken = localStorage.getItem("JWTRefreshToken");
                if (!storedToken) {
                    throw new Error("No refresh token found");
                }

                const refreshToken = JSON.parse(storedToken);
                if (!refreshToken) {
                    throw new Error("Refresh token is null");
                }

                // Make the API call to refresh the token
                const res = await axiosJWT.post("/Authentication/Refresh", {
                    refreshToken,
                });

                const { accessToken, refreshToken: newRefreshToken } = res.data;

                // Store the new tokens
                localStorage.setItem("JWTToken", JSON.stringify(accessToken));
                localStorage.setItem(
                    "JWTRefreshToken",
                    JSON.stringify(newRefreshToken),
                );

                return accessToken;
            } catch (error) {
                console.error("Token refresh failed", error);
                localStorage.clear(); // clean the storage
                window.location.reload(); // and force reset
                // throw error; // Propagate the error if token refresh fails
            } finally {
                refreshTokenPromise = null; // Reset the promise after resolution or failure
            }
        })();
    }

    // Return the ongoing promise whether it's already in progress or newly created
    return refreshTokenPromise;
};

// Interceptor for requests to add the Authorization header
axiosSW.interceptors.request.use(
    async (config) => {
        const token = JSON.parse(localStorage.getItem("JWTToken"));
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error),
);
// when the repond is 401 error the interceptor will try to refresh the token using the refreshAccessToken() function, and if successful it wil reexcute the rejected requests in the background
// Interceptor for responses to handle 401 errors and token refresh
axiosSW.interceptors.response.use(
    (response) => response, // If the response is successful, return it
    async (error) => {
        const originalRequest = error.config;

        // If the response status is 401 and the original request hasn't been retried yet
        if (error.response?.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;

            try {
                const newToken = await refreshAccessToken();
                originalRequest.headers.Authorization = `Bearer ${newToken}`;
                return axiosSW(originalRequest); // Retry the original request with the new token
            } catch (err) {
                console.error("Token refresh failed", err);

                return Promise.reject(err);
            }
        }

        return Promise.reject(error); // Reject the original error if it's not a 401 or the token refresh failed
    },
);

//--------------------------------------------------------------- probably temporary
// this is for payment stripe connect new endpoints
// Interceptor for requests to add the Authorization header
axiosSW2.interceptors.request.use(
    async (config) => {
        const token = JSON.parse(localStorage.getItem("JWTToken"));
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error),
);
// when the repond is 401 error the interceptor will try to refresh the token using the refreshAccessToken() function, and if successful it wil reexcute the rejected requests in the background
// Interceptor for responses to handle 401 errors and token refresh
axiosSW2.interceptors.response.use(
    (response) => response, // If the response is successful, return it
    async (error) => {
        const originalRequest = error.config;

        // If the response status is 401 and the original request hasn't been retried yet
        if (error.response?.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;

            try {
                const newToken = await refreshAccessToken();
                originalRequest.headers.Authorization = `Bearer ${newToken}`;
                return axiosSW2(originalRequest); // Retry the original request with the new token
            } catch (err) {
                console.error("Token refresh failed", err);

                return Promise.reject(err);
            }
        }

        return Promise.reject(error); // Reject the original error if it's not a 401 or the token refresh failed
    },
);
